import React from 'react';
import { ModalContent } from 'fronton-react';
import { List, ListItem, ModalHeader, Typography } from 'common/components';
import {
  newKitchenUtpSectionModalContent,
  newKitchenUtpSectionModalList,
  newKitchenUtpSectionModalText,
} from '../../new-kitchen-utp-section-styles';

export const Support: React.FC = () => (
  <>
    <ModalHeader title="Сервисная поддержка" />
    <ModalContent className={newKitchenUtpSectionModalContent}>
      <Typography className={newKitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        С&nbsp;нами удобно и&nbsp;надёжно!
      </Typography>
      <List className={newKitchenUtpSectionModalList} listStyle="disc">
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Будем рядом на&nbsp;каждом этапе&nbsp;&mdash; от&nbsp;проектирования до&nbsp;установки
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Соберём кухню и&nbsp;установим технику качественно и&nbsp;профессионально
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Останемся на&nbsp;связи и&nbsp;после завершения проекта, чтобы ваша кухня радовала вас долгие
            годы
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
  </>
);
